// extracted by mini-css-extract-plugin
module.exports = {"heroSection":"hero-section-module--hero-section--31qgQ","heroImage":"hero-section-module--hero-image--qtDmw","overlay":"hero-section-module--overlay--1uRnd"};